import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Clock, ArrowRight } from 'lucide-react';
import { AlmondIcon } from './AlmondIcon';

export default function PickupModal({ open, onClose }) {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  const goToShop = () => {
    onClose();
    navigate('/products');
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-[#2C3A28]/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md rounded-3xl bg-[#E9EBED] shadow-2xl overflow-hidden fade-up">
        <div className="h-2 bg-gradient-to-r from-[#2C3A28] via-[#2C3A28] to-[#2C3A28]" />
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-9 h-9 rounded-full flex items-center justify-center text-[#2C3A28] hover:bg-[#EDEAE0] transition-colors"
          aria-label="Close"
          data-testid="pickup-modal-close"
        >
          <X size={20} />
        </button>
        <div className="px-8 pt-9 pb-10 text-center">
          <div className="mx-auto w-14 h-14 rounded-2xl bg-[#EDEAE0] flex items-center justify-center text-[#2C3A28]">
            <Clock size={26} />
          </div>
          <h3 className="mt-5 font-display text-3xl font-semibold text-[#2C3A28]">
            In store pick up
          </h3>
          <p className="mt-3 text-[#3B2A20]/75 leading-relaxed">
            Please place your order by <span className="font-semibold text-[#2C3A28]">4:00pm the day before</span> so
            we can have your freshly made nut milk ready for collection in store.
          </p>
          <button
            onClick={goToShop}
            data-testid="pickup-shop-range-btn"
            className="group mt-7 w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#2C3A28] text-white py-4 font-semibold hover:bg-[#2C3A28] transition-colors"
          >
            <AlmondIcon size={16} className="text-[#D2B489]" />
            Shop the range
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </div>
  );
}
